import React from 'react';
import { Users, Tent, Compass } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    lbl: 'BONO 1',
    Icon: Users,
    title: 'Directorio de +50 proveedores verificados en Argentina',
    desc: 'CABA, GBA, Córdoba, Rosario, Santa Fe, Mendoza, Tucumán y todo el interior. Mayoristas de joyas, plata 925 y oro. Listos para contactar hoy mismo.'
  }, {
    lbl: 'BONO 2',
    Icon: Tent,
    title: 'Directorio de 39 ferias y mercados en todo el país',
    desc: 'Nombre, ubicación, día y rubro de cada feria. Más: tips de armado de puesto, guión de venta presencial y checklist de tu primera feria.'
  }, {
    lbl: 'BONO 3',
    Icon: Compass,
    title: 'Guía de campo para zonas mayoristas',
    desc: 'El Once, GBA zona norte, oeste y sur. Qué decir, cómo negociar, señales de alerta y sistema de reposición remota. Para llevar en el celular al comprar.'
  }];
  return <section className="bg-gold/5 py-12 sm:py-20" data-id="element-35">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-36">
        <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-37">
          Incluidos gratis
        </div>
        <h2 className="mb-4 font-serif text-[clamp(24px,4vw,38px)] font-bold leading-[1.2] text-white" data-id="element-38">
          3 Bonos Estratégicos
        </h2>
        <p className="mb-8 sm:mb-12 max-w-[560px] text-[15px] text-text" data-id="element-39">
          Sin costo extra — incluidos en todas las ofertas. Herramientas de
          campo para usar desde el primer día.
        </p>

        <div className="flex flex-col gap-3" data-id="element-40">
          {bonuses.map((bono, i) => {
          const {
            Icon
          } = bono;
          return <div key={i} className="flex items-start gap-4 rounded-xl border border-border bg-[#0e0b00] p-4 transition-colors duration-300 hover:border-gold/40 sm:items-center sm:p-5" data-id="element-41">
                {/* Representative icon tile (SVG — instant load) */}
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-gold/20 bg-gold/10" data-id="element-42">
                  <Icon className="h-6 w-6 text-gold" strokeWidth={1.75} data-id="element-43" />
                </div>

                <div className="flex-1 min-w-0" data-id="element-44">
                  <div className="mb-1 flex flex-wrap items-center gap-2" data-id="element-45">
                    <span className="inline-block rounded-[3px] bg-gold px-2 py-0.5 text-[9px] font-bold tracking-[0.1em] text-[#111]" data-id="element-46">
                      {bono.lbl}
                    </span>
                    <span className="text-[10px] font-bold uppercase tracking-[0.08em] text-gold" data-id="element-47">
                      GRATIS
                    </span>
                  </div>
                  <div className="mb-1 text-[14px] font-semibold text-white" data-id="element-48">
                    {bono.title}
                  </div>
                  <div className="text-[12px] leading-[1.6] text-muted" data-id="element-49">
                    {bono.desc}
                  </div>
                </div>
              </div>;
        })}
        </div>

        <p className="mt-7 text-center text-[15px] text-muted" data-id="element-50">
          Valor real de los bonos:{' '}
          <strong className="font-bold text-white" data-id="element-51">
            incluidos sin costo adicional en ambas ofertas.
          </strong>
        </p>
      </div>
    </section>;
}